import { render } from "./MatineesPage.vue?vue&type=template&id=0d0239e2"
import script from "./MatineesPage.vue?vue&type=script&lang=js"
export * from "./MatineesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__